import { IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED } from '@/features/flags/legacy-flags';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useQueryUserBillingInfo } from './useQueryUserBillingInfo';

const useQueryUserTier = () => {
  const { data: billingInfo } = useQueryUserBillingInfo();

  const newUserTier = IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED()
    ? billingInfo?.new_product_tier
    : billingInfo?.tier;
  const userTier = billingInfo?.third_party_license?.latest_tier || newUserTier;

  const isTogetherOrHigherTier = [
    SubscriptionTier.PRO_PLUS,
    SubscriptionTier.ENTERPRISE,
    SubscriptionTier.CLINICIAN_PRO_PLUS,
    SubscriptionTier.CLINICIAN_ENTERPRISE,
  ].includes(userTier ?? SubscriptionTier.FREE);

  return {
    userTier,
    newUserTier,
    isTogetherOrHigherTier,
  };
};

export default useQueryUserTier;
